import React, {useEffect, useState} from "react";
import { useQueryClient } from "@tanstack/react-query";
import { UserApi } from "../app/api/user.api";
import { RepositoryApi } from "../app/api/repository.api";


const userInstance1 = UserApi('multipart/form-data');

export function Form1({onChange})
{
    return(

        <div className="row mb-4">
            {/* -------------------------------------------------------------------- */}
            <div className="col-lg-12 border p-4 rounded-2 bg-white">
                {/* +++++++++++++++++++++++ */}
                <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input1" className="font-xs text-muted"> Nom d'utilsateur </label>
                            <input type="text" name="username" className="form-control text-muted" placeholder="Username" id="input1" onChange={onChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <label htmlFor="input2" className="font-xs text-muted" > Email </label>
                            <input type="mail" name="email" className="form-control text-muted" placeholder="example@mail.com" id="input2" onChange={onChange}  required/>
                        </div>
                    </div>
                </div>
                {/* +++++++++++++++++++++++ */}
                <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input3" className="font-xs text-muted"> Profession</label>
                            <select name="occupation" id="input3" className="form-control text-muted" onChange={onChange} required>
                                <option value=""> Choisir une profession </option>
                                <option value="Etudiant"> Etudiant </option>
                                <option value="Professeur"> Professeur </option>
                                <option value="Eleve"> Eleve </option>
                                <option value="Autres"> Autres </option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <label htmlFor="input4" className="font-xs text-muted" > Université </label>
                            <select name="university" id="input4" className="form-control text-muted" onChange={onChange} required>
                                <option value=""> Choisir une université </option>
                                <option value="Universite Cheikh Anta Diop"> Universite Cheikh Anta Diop de Dakar </option>
                                <option value="Universite Gaston berger"> Universite Gaston berger de Saint Louis </option>
                                <option value="Universite Sine Saloum Elhadji Ibrahima Niass"> Universite Sine Saloum Elhadji Ibrahima Niass </option>
                                <option value="Universite Iba Der Thiam"> Universite Iba Der Thiam de Thies </option>
                                <option value="Universite Assane Seck de Ziguinchor"> Universite Assane Seck de Ziguinchor </option>
                                <option value="Universite Cheikh Hamidou Kane"> Universite Cheikh Hamidou Kane du Senegal</option>
                                <option value="Universite Amadou Makhtar Mbow de Diamiadio"> Universite Amadou Makhtar Mbow de Diamiadio </option>
                                <option value="Autres universite"> Autres instituts universitaires </option>
                            </select>
                        </div>
                    </div>
                </div>
                {/* +++++++++++++++++++++++ */}
                <div className="row mb-4">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input5" className="font-xs text-muted"> Mot de passe </label>
                            <input type="password" name="password" className="form-control text-muted" id="input5" onChange={onChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <label htmlFor="input6" className="font-xs text-muted" > Confirmer mot de passe </label>
                            <input type="password" name="cpassword" className="form-control text-muted" id="input6" onChange={onChange} required />
                        </div>
                    </div>
                </div>
                {/* +++++++++++++++++++++++ */}
            </div>
        </div>
    )
}


export function Form2({onChange})
{
    return(
        <div className="row mb-4">
            {/* -------------------------------------------------------------------- */}
            <div className="col-lg-12 border p-4 rounded-2">
                {/* +++++++++++++++++++++++ */}
                {/* <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input7" className="text-secondary font-xs"> Prenom </label>
                            <div className="d-flex gap-1 mb-3" >
                                <input type="text" name="fname" className="w-100 border input py-3 px-3 text-secondary rounded-2" placeholder="Prenom" id="input7" onChange={handleInputs} required />
                                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <label htmlFor="input8" className="text-secondary font-xs" > Nom </label>
                            <div className="d-flex gap-1 mb-3" >
                                <input type="text" name="lname" className="w-100 border input py-3 px-3 text-secondary rounded-2" placeholder="Prenom" id="input7" onChange={handleInputs} required />
                                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* +++++++++++++++++++++++ */}
                <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input9" className="text-muted font-xs"> Date de naissance ( <span className="color-orange"> optionnelle </span> ) </label>
                            <input type="date" max={'2015-01-01'} name="birthDate" className="form-control text-muted" onChange={onChange} id="input9" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="">
                            <label htmlFor="input10" className="text-muted font-xs" > Lieu de naissance ( <span className="color-orange"> optionnelle </span> ) </label>
                            <input type="text" name="birthPlace" className="form-control text-muted" onChange={onChange} id="input10"/>
                        </div>
                    </div>
                </div>
                {/* +++++++++++++++++++++++ */}
                <div className="row mb-4">
                    <div className="col-md-6 mb-2">
                        <div className="">
                            <label htmlFor="input11" className="text-muted font-xs"> Sexe </label>
                            <select name="sex" id="input11" className="form-control text-muted" onChange={onChange} required>
                                <option value=""> Choisir sexe </option>
                                <option value="masculin"> Masculin </option>
                                <option value="feminin"> Feminin </option>
                            </select>
                        </div>
                    </div>
                </div>
                {/* +++++++++++++++++++++++ */}
            </div>
            {/* -------------------------------------------------------------------- */}
        </div>
    )
}




export function UserForm({ data })
{
    const user = UserApi();
    const queryClient = useQueryClient();

    const [inputs, setInputs] = useState({
      fname: "",
      lname: "",
      sex: "",
      occupation: "",
      institut: "",
    });

    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (data) {
          setInputs({
            fname: data.fname || "",
            lname: data.lname || "",
            sex: data.sex || "",
            occupation: data.occupation || "",
            institut: data.institut || ""
          });
        }
    }, [data]);

        
    const handleInputs = ( event ) => {
        const { name , value } =  event.target 
        setInputs( { ...inputs, [name] : value  } ) 
    }
        
    const handleForm = async ( event ) => {
        event.preventDefault();
        setIsLoading(true);
        setStatus(0);
        
        try {
            const {data} = await user.updateOne(inputs);
            setIsLoading(false);
            if (data.success){
               setStatus(1);
               queryClient.invalidateQueries({ queryKey: ["user"] });
            } else {
               setStatus(-1); 
            }         
        } catch (err) { 
            setIsLoading(false);
            setStatus(-1); 
        }  
    } 

    return(
        <div className="col-lg-4 border-start border-bottom bg-light p-0">
            <div className="d-flex justify-content-between py-3 border-bottom px-4">
                <span className="font-lg text-muted"> Formulaire de modification </span> 
            </div>
            <div className="p-3">
                <form className="d-flex flex-column p-4 bg-white border rounded-3 w-100" onSubmit={handleForm}>
                    <div className="row"> 
                        <div className="col-lg-12 col-md-6 mb-2">
                            <div className="d-flex flex-column">
                                <label htmlFor="input2" className="text-muted font-xs"> Prénom </label>
                                <div className="d-flex gap-1">
                                    <input type="text" name="fname" value={ inputs?.fname } className="input text-secondary border rounded p-3 w-100" placeholder="Prenom" id="input2" onChange={handleInputs} required />
                                    <span className="text-danger border rounded p-3"> * </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-6 mb-2">
                            <div className="d-flex flex-column">
                                <label htmlFor="input3" className="text-muted font-xs" > Nom </label>
                                <div className="d-flex gap-1">
                                    <input type="text" name="lname" value={ inputs?.lname } className="input text-secondary border rounded p-3 w-100" placeholder="Nom" id="input3" onChange={handleInputs} required/>
                                    <span className="text-danger border rounded p-3"> * </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-6 mb-2">
                            <div className="d-flex flex-column">
                                <label htmlFor="input6" className="text-muted font-xs"> Sexe </label>
                                <div className="d-flex gap-1">
                                    <select name="sex" value={ (inputs?.sex === 'male' )  ? 'Masculin' : 'Feminin'  } id="input6" className="input text-secondary border rounded p-3 w-100"  onChange={handleInputs} >
                                        <option value=""> Choisir le sexe </option>
                                        <option value="male"> Masculin </option>
                                        <option value="female"> Feminin </option>
                                    </select>
                                    <span className="text-danger border rounded p-3"> * </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-6 mb-2">
                            <div className="d-flex flex-column">
                                <label htmlFor="input7" className="font-xs text-muted"> Profession</label>
                                <div className="d-flex gap-1">
                                    <select name="occupation" value={ inputs?.occupation } id="input7" className="input text-secondary border rounded p-3 w-100" onChange={handleInputs} >
                                        <option value=""> Choisir une profession </option>
                                        <option value="Etudiant"> Etudiant </option>
                                        <option value="Professeur"> Professeur </option>
                                        <option value="Eleve"> Eleve </option>
                                        <option value="Autres"> Autres </option>
                                    </select>
                                    <span className="text-danger border rounded p-3"> * </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-6 mb-4">
                            <div className="d-flex flex-column">
                                <label htmlFor="input8" className="font-xs text-muted" > Universite </label>
                                <div className="d-flex gap-1">
                                    <select name="institut" value={ inputs?.institut } id="input8" className="input text-secondary border rounded p-3 w-100" onChange={handleInputs} >
                                        <option value=""> Choisir une institut </option>
                                        <option value="Universite Cheikh Anta Diop"> Universite Cheikh Anta Diop de Dakar </option>
                                        <option value="Universite Gaston berger"> Universite Gaston berger de Saint Louis </option>
                                        <option value="Universite Sine Saloum Elhadji Ibrahima Niass"> Universite Sine Saloum Elhadji Ibrahima Niass </option>
                                        <option value="Universite Iba Der Thiam"> Universite Iba Der Thiam de Thies </option>
                                        <option value="Universite Assane Seck de Ziguinchor"> Universite Assane Seck de Ziguinchor </option>
                                        <option value="Universite Cheikh Hamidou Kane"> Universite Cheikh Hamidou Kane du Senegal</option>
                                        <option value="Universite Amadou Makhtar Mbow de Diamiadio"> Universite Amadou Makhtar Mbow de Diamiadio </option>
                                        <option value="Autres universite"> Autres instituts universitaires </option>
                                    </select>
                                    <span className="text-danger border rounded p-3"> * </span>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-lg-12">
                            <div className="row">
                                    {
                                      isLoading && (
                                        <div className="col-lg-12 d-flex justify-content-center align-items-center mb-4"> 
                                          <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === -1 && (
                                        <div className="col-lg-12 mb-3">
                                          <div className="alert alert-danger">
                                             Une erreur est survenue lors de la creation de votre compte, veuillez rééssayer.
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === 1 && (
                                        <div className="col-md-12 mb-3">
                                          <div className="alert alert-success">
                                            Informations mises à jour avec succès.
                                          </div>
                                        </div>
                                      )
                                    }  
                            </div>
                        </div>

                        <div className="col-12 d-flex justify-content-end"> 
                            <button className="btn btn-green py-2" type="submit"> Enregistrer <i className="bi bi-arrow-right ms-1"></i> </button> 
                        </div>

                    </div> 
                </form>
            </div> 
        </div>
    )
}



export function Form3({ data })
{

    const repInstance =  RepositoryApi();

    const [inputs, setInputs] = useState({
        name: "",
        level:  "",
        description: ""
    });

    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (data) {
          setInputs({
            name: data?.name || "",
            level: data?.level || "",
            description: data?.description || ""
          });
        }
    }, [data]);
                   
    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value  } ) ; 
    }
                
    const handleForm = async ( event ) => {
        event.preventDefault();
        setIsLoading(true);
        setStatus(0);
         try {
            const res = await repInstance.updateOne(data?.id, inputs)

            setIsLoading(false);
            if (res.data.success){
               setStatus(1);
            } else {
               setStatus(-1); 
            }         
        } catch (err) { 
            setIsLoading(false);
            setStatus(-1); 
        }  
  
    }


    return(

        <div className="p-4 mb-5">                  
            <form className="p-4 border rounded-3 bg-white" onSubmit={handleForm}>
                <div className="row">
                    {
                      isLoading && (
                        <div className="col-lg-12 d-flex justify-content-center align-items-center mb-4"> 
                          <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                        </div>
                      )
                    }
                     {
                      status === -1 && (
                        <div className="col-lg-12 mb-3">
                          <div className="alert alert-danger">
                             Une erreur est survenue durant la mise à jour des informations, veuillez rééssayer.
                          </div>
                        </div>
                      )
                    }
                    {
                      status === 1 && (
                        <div className="col-md-12 mb-3">
                          <div className="alert alert-success">
                            Informations mises à jour avec succès.
                          </div>
                        </div>
                      )
                    }  
                </div>
                <div className="mb-3">
                    <label htmlFor="input1" className="small text-secondary" required> Nom du repertoire (<span className="color-orange"> obligatoire </span>)</label>
                    <input type="text" name="name" value={ inputs?.name } className="border rounded p-3 text-muted input w-100" id="input1" onChange={handleInputs} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="input2" className="small text-secondary"> cycle universitaire (<span className="color-orange"> obligatoire</span>) </label>
                    <select className="border rounded p-3 text-muted input w-100" value={ inputs?.level } name="level" id="input2" onChange={handleInputs} required >
                        <option value=""> Choisir un cycle </option>
                        <option value="Licence"> Licence </option>
                        <option value="Master"> Master </option>
                        <option value="Doctorat"> Doctorat </option>
                        <option value="Autres"> Autres </option>
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="input3" className="small text-secondary"> Description (<span className="color-orange"> optionelle </span>) </label>
                    <textarea className="border rounded p-3 text-muted input w-100" name="description" value={ inputs?.description } rows="5" id="input3" onChange={handleInputs} ></textarea>
                </div>
                <div className="d-flex justify-content-end"> <button type="submit" className="btn btn-green"> Enregistrer </button> </div>
            </form> 
        </div>
    )
}





export function ImageProfil({ data, isLoading }) {

  const queryClient = useQueryClient();

  const [file, setFile] = useState(null);              
//   const [preview, setPreview] = useState(null);         
  const [response, setResponse] = useState(-1);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (file) {
      const objectUrl = URL.createObjectURL(file);
    //   setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [file]);

  const handleForm = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await userInstance1.updateImage(formData);

      if (res.data.success === true) {
        setMessage("Image modifiée avec succès");
        setResponse(1);
        queryClient.invalidateQueries({ queryKey: ["user"] });
      } else {
        setMessage("Erreur ! taille max: 5 Mo et formats acceptés: jpg, png, jpeg");
        setResponse(0);
      }
    } catch (error) {
      setMessage("Erreur ! taille max: 5 Mo et formats acceptés: jpg, png, jpeg");
      setResponse(0);
    }
  };

  const cancelChange = () => {
    setFile(null);
    // setPreview(null);
    setResponse(-1);
  };

//    let displayedImage = preview || (data ? data.imagePath : "../img/icons8-student-64.png");

  return (
    <div className="row border-bottom pb-3">
      <div className="col-12 px-4 pb-4">
        <form className="d-flex flex-column align-items-center" onSubmit={handleForm}  encType="multipart/form-data" >

          {/* ---------- IMAGE AVEC SKELETON ---------- */}
          <div className="d-flex justify-content-center">
            { isLoading ? (
              <div className="rounded-circle bg-secondary" style={{ height: "160px", width: "160px", opacity: 0.3, animation: "pulse 1.5s infinite" }}></div>
            ) : (
              <img className="rounded-circle border border-5"  height="160px" width="160px" src={ data?.image } alt="profile" />
            )}
          </div>
          {/* ---------- BOUTON POUR CHOISIR IMAGE ---------- */}
          {!isLoading && (
            <div className="d-flex justify-content-center">
              <label htmlFor="file-picker" className="d-flex pos-picture justify-content-center shadow cursor align-items-center bg-light p-2 rounded-2 text-secondary">
                <i className="bi bi-arrow-right ms-2"></i> 
              </label>
              <input name="image" type="file" className="hidden" id="file-picker" onChange={(e) => setFile(e.target.files[0])} />
            </div>
          )}
          {/* ---------- MESSAGES ---------- */}
          {response === 1 ? (
            <span className="text-center small text-muted alert alert-success">{message}</span>
          ) : response === 0 ? (
            <span className="text-center small text-muted alert alert-danger">{message}</span>
          ) : null}

          <span className="font-sm text-center text-secondary">{file ? file.name : ""}</span>

          {/* ---------- BOUTONS APPARAISSENT SI UNE IMAGE A ÉTÉ CHANGÉE ---------- */}
          {file && (
            <div className="d-flex gap-3 mt-3">
              <button className="btn btn-sm btn-green-outline" type="submit">
                Enregistrer
              </button>
              <button className="btn btn-sm btn-outline-danger" type="button" onClick={cancelChange} >
                Annuler
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
